export const TOOLTIP_INFO = {
  TEMPLATES: {
    TITLE: 'All-template compliance snapshot',
    DESCRIPTION:
      'This view shows the current status of each template — including the last submission date, total rows submitted, and your data standards score. Row counts reflect the full dataset tied to that template, which may include data older than 6 months. The compliance score is based on current errors surfaced through the UI over the past 6 months.',
  },
  SUBMISSIONS: {
    TITLE: 'User submissions',
    DESCRIPTION:
      'This chart tracks how many rows have been submitted — complete vs errored — across all users over the past 6 months. These counts show when rows were processed or flagged in the UI, not when the data was originally created. Some rows may originate from older templates or datasets.',
  },
  ENGAGEMENT: {
    TITLE: 'User engagement with submissions',
    DESCRIPTION:
      'This chart shows patterns of user activity over time — who’s actively submitting data versus who isn’t. The timeframe represents user interactions with the submission UI in the past 6 months, not necessarily the age of the data itself.',
  },
  GRAPH: {
    TITLE: 'All rows synced with integrations',
    DESCRIPTION:
      'This diagram shows all rows that have been processed and sent to connected platforms. Each number reflects a processed row that was included in a sync — even if the same row was edited or reused across templates. Rows are not deduplicated across integrations; instead, each sync reflects a separate push of data.',
  },
}
